import { createStore } from 'vuex'

export default createStore({
  state: {
    token: '',
    personalInformation: {} // 个人信息
  },
  mutations: {
    tokenClick(state, params) {
      console.log(state, params,'token存储');
      state.token = params
    },
    personalInformation(state, params) {
      console.log(state, params,'vueX个人信息');
      state.personalInformation = params
    }
  },
  actions: {
  },
  modules: {
  }
})
